"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var prismjs_1 = __importDefault(require("prismjs"));
require("prismjs/themes/prism-okaidia.css");
require("prismjs/plugins/toolbar/prism-toolbar");
require("prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var DescriptionWrapper_1 = __importDefault(require("./styles/DescriptionWrapper"));
var ImportCodeWrapper_1 = __importDefault(require("./styles/ImportCodeWrapper"));
var ImportCodeTemplate = function (_a) {
    var heading = _a.heading, description = _a.description, renderCode = _a.renderCode;
    prismjs_1.default.highlightAll();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ p: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: heading })), description && (0, jsx_runtime_1.jsx)(DescriptionWrapper_1.default, { children: description }), (0, jsx_runtime_1.jsx)(ImportCodeWrapper_1.default, { children: (0, jsx_runtime_1.jsx)("pre", { children: (0, jsx_runtime_1.jsx)("code", __assign({ className: "language-js" }, { children: renderCode })) }) })] })));
};
exports.default = ImportCodeTemplate;
